import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "900")};
`;
